<template>
  <div class="flex min-h-screen w-full max-w-[dvw] flex-col justify-between overflow-y-hidden">
    <BusinessReportNavigation v-if="isBusinessReport" />
    <AppNavigation v-else />

    <main class="flex flex-1 flex-col">
      <NuxtPage @update:entry="entry = $event" />
    </main>

    <AppFooter />
  </div>
</template>

<script lang="ts" setup>
import type { PageQuery } from '#gql'

const { initialize } = useGtag()
// Fetch globals
const globals = await useInjectableGlobals().catch((error) => {
  throw createError({
    fatal: true,
    statusCode: error?.status ?? 500,
    message: error instanceof Error ? error.message : 'Couldn\'t fetch globals',
  })
})
provide(GlobalsKey, globals)

const entry = ref<PageQuery['entry'] | null>(null)
provide(EntryInjectionKey, entry)

const isBusinessReport = useIsBusinessReport()

useSeotamicCustom(entry)

const config = useRuntimeConfig()
function initializeGtag() {
  const gtId = isBusinessReport.value ? config.public.GOOGLE_TAG_MANAGER_ID_BR : config.public.GOOGLE_TAG_MANAGER_ID

  if (!gtId) {
    console.warn('Google Tag Manager ID is not set. Skipping initialization.')
    return
  }

  initialize(gtId)
}

onMounted(() => {
  initializeGtag()
  window.addEventListener('keydown', navigateToSearchPage)
})

onUnmounted(() => {
  window.removeEventListener('keydown', navigateToSearchPage)
})

// -- METHODS --
const router = useRouter()
const localePath = useLocalePath()

function navigateToSearchPage(e) {
  if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
    return router.push(localePath('search'))
  }
}
</script>
